import React from 'react';
import {AppRoot} from 'core-app';
import { appConfig} from './AppConfig';

export const MyApp:React.FC = () => <AppRoot appConfig={appConfig}/>

